/**
 * Busca el registro de stock que corresponde a la selección actual.
 */
export function findStockForSelection(stocks, selectedPrice, selectedColor) {
  if (!stocks?.length) return null;

  return stocks.find((s) => {
    const priceMatch = selectedPrice
      ? s.precio_id === selectedPrice.id
      : true;
    const colorId = selectedColor?.leora_colores_UUID ?? null;
    const stockColorId = s.color_id ?? null;
    return priceMatch && stockColorId === colorId;
  }) ?? null;
}

/**
 * Estado de la variante: disponible | agotado | proximamente.
 */
export function getVariantStatus(product, selectedPrice, selectedColor) {
  const stocks = product?.stocks ?? [];
  const match = findStockForSelection(stocks, selectedPrice, selectedColor);

  if (!match) {
    if (stocks.length > 0) return 'agotado';
    if (product?.estado === 'proximamente') return 'proximamente';
    if (product?.estado === 'agotado') return 'agotado';
    return 'disponible';
  }

  if (match.estado === 'proximamente') return 'proximamente';
  if (match.estado === 'agotado') return 'agotado';
  if (match.cantidad <= 0) return 'agotado';
  return 'disponible';
}

export function isColorAgotadoForPrice(stocks, price, color, product) {
  return getVariantStatus({ stocks, estado: product?.estado }, price, color) === 'agotado';
}

export function isPriceAgotadoForColor(stocks, price, color, product) {
  return isColorAgotadoForPrice(stocks, price, color, product);
}

export function priceLabel(p, formatPrice) {
  const desc = p?.descripcion?.trim();
  return desc || formatPrice(p.valor);
}

export function findFirstAvailableSelection(product) {
  const precios = product?.precios || [];
  const colores = product?.colores || [];

  if (!precios.length) {
    return { price: null, color: null };
  }

  if (!colores.length) {
    const price = precios.find(
      (p) => getVariantStatus(product, p, null) === 'disponible',
    ) || precios[0];
    return { price, color: null };
  }

  for (const price of precios) {
    for (const color of colores) {
      if (getVariantStatus(product, price, color) === 'disponible') {
        return { price, color };
      }
    }
  }

  return { price: precios[0], color: colores[0] };
}
